import { ref, computed, Ref } from "vue";
import { MstSyouninGroupsService } from "@/service/MstSyouninGroupsService";
import OptionConst from '@/const/Option';
import { HakensakiShimeCheckData } from "@/types/MyTask";

/*
 * 初期処理
 */
export function useHakensakiShimeCheckInit() {
  const loading = ref(0); // APIで読み込みをする本数
  const isError = ref(false);

  // 派遣先上長承認グループの月締め情報
  const hakenStaffList:Ref<HakensakiShimeCheckData[]> = ref([]);

  const srv = new MstSyouninGroupsService();

  //   // ユーザー情報の取得
  //   const authStore = useAuthStore();
  //   const user = authStore.user;

  //   if (user == null) {
  //     // エラー
  //     loading.value--;
  //     isError.value = true;
  //   } else {
  //     // 自身が承認者である承認グループ情報を取得する
  //     srv.getGroupMember(user.user_id).then((r: GroupWithMember[] | null) => {
  //       if (r !== null) {
  //         loading.value--;
  //         console.log('res');
  //         console.log(r);
  //         // 打刻承認の分を代入する
  //         form.value = r.filter((v: any) => v.syounin_type == OptionConst.SYOUNIN_FLOW_TYPES.DAKOKU_SYOUNIN);
  //       } else {
  //         // エラー
  //         isError.value = true;
  //       }
  //     });
  //   }

  const syouninStatus = (statusId: number) => {
    const status = OptionConst.DAKOKU_SYOUNIN_STATUS_OPTION.find(item => item.val === statusId)
    if (status) {
      return status.label
    } else {
      return '-'
    }
  }

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value);
  });

  return {
    hakenStaffList,
    isLoading,
    isError,
    syouninStatus,
  }
}
